export interface UpdateCustomerAckDocument {
  engagementId?: number;
  fileName?: string;
  fileURL?: string;
  documentType?: string;
}
export enum PreviewDocumentTypes {
  poedocument = 'poedocument',
  customerAcknowledgement = 'Customer Acknowledgement',
  poeinvoice = 'Poe Invoice',
  customerSurvey = 'Customer Survey',
  additionalDocument = 'Additional Document',
  rfpDescription = 'Request For Proposal Description',
  rfpAward = 'Request For Proposal Award Letter',
  partnerSurvey = 'Partner Survey',
  SOW = 'Statement of Work'
}
